/*******************************************************************************
 * state.js - Centralized State Management
 * 
 * All shared mutable state is stored here to avoid circular dependencies
 * and make state changes trackable.
 ******************************************************************************/

// Create a state store object
const state = {
    // Dialog reference
    dialogObj: null,
    
    // Totals and counts
    total: 0,
    count: 0,
    
    // Selected bills
    billsSelected: [],
    newDataRecord: [],
    
    // Bank account info
    bankAccount: "",
    bankAccountName: "",
    bankAccountCode: "",
    bankAccountID: "",
    orgName: "",
    
    // Table and grid
    table: null,
    totalRowCount: 0,
    objSelectedBills: null,
    elementIDName: [],
    
    // Mark as paid
    markAsPaidResult: undefined,
    disabledGridEditing: false,
    
    // Invoice validation
    selectedInvoiceWithNoBankDetails: [],
    selectedInvoiceWithNoBankDetailsReportExport: [],
    
    // Pagination
    selectedPageSizes: undefined,
    flag: true,
    isPaid: true,
    isFormatChecking: false,
    currentPagerValue: 500,
    selectedPageSize: undefined,
    
    // BACS/Export options
    txtBacsServiceUserNo: "",
    txtNarrativeUserChoice: "",
    txtBatchReferenceNo: "",
    chksumInvoicesPerContact: true,
    showLodgementReference: false,
    
    // Grid editing
    cellEditRowIndex: null,
    
    // Subscription
    isTrialPeriodShow: undefined,
    subscriptionID: undefined,
    
    // Bank options
    bankOptionSelected: "",
    bankOption: false,
    isDbb: false,
    desc: "",
    
    // Window dimensions
    windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    
    // Download info
    downloadInfo: {},
    storedData: []
};

// Getters
export function getState(key) {
    return state[key];
}

// Setters
export function setState(key, value) {
    state[key] = value;
}

// Batch update
export function updateState(updates) {
    Object.assign(state, updates);
}

// Reset specific keys
export function resetState(keys) {
    keys.forEach(key => {
        if (key === 'billsSelected' || key === 'newDataRecord' || 
            key === 'selectedInvoiceWithNoBankDetails' || 
            key === 'selectedInvoiceWithNoBankDetailsReportExport' ||
            key === 'elementIDName' || key === 'storedData') {
            state[key] = [];
        } else if (key === 'total' || key === 'count' || key === 'totalRowCount' || 
                   key === 'currentPagerValue') {
            state[key] = key === 'currentPagerValue' ? 500 : 0;
        } else if (typeof state[key] === 'boolean') {
            state[key] = key === 'flag' || key === 'isPaid' || key === 'chksumInvoicesPerContact';
        } else if (typeof state[key] === 'string') {
            state[key] = "";
        } else {
            state[key] = null;
        }
    });
}

// Export the entire state for backward compatibility
export default state;

// Initialize window.gridSelection
if (typeof window !== 'undefined') {
    window.gridSelection = window.gridSelection || {};
}
